import {h, Fragment} from "preact"
import { useProductFilters } from "@nosto/preact"

export default function SelectedFilters() {
    const { filters, removeAll } = useProductFilters()

    return (
        filters.length > 0 && (
            <div class="ns-page-width">
                <div class="ns-selected-filters-list ns-flex ns-flex-wrap ns-items-center">
                    {filters.map(filter => (
                        <button
                            key={`${filter.name}: ${filter.value}`}
                            type="button"
                            aria-label={`Remove ${filter.value} filter`}
                            class="ns-selected-filter ns-flex ns-items-center"
                            onClick={() => filter.remove()}
                        >
                            <span class="">
                                {filter.value.toLowerCase().trim() === "true" ? "On Sale" : filter.value}
                            </span>
                            <svg class="ns-selected-filter-svg block" aria-hidden="true" role="presentation" focusable="false" width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0.5 1L7 7.5" stroke="white"/>
                                <path d="M7 1L0.5 7.5" stroke="white"/>
                            </svg>
                        </button>
                    ))}
                    {/* <button
                        type="button"
                        aria-label="Clear all filters"
                        class=""
                        onClick={removeAll}
                    >
                        Clear Filters
                    </button> */}
                </div>
            </div>
        )
    )
}
